import React, { useEffect } from 'react';
import Tarif from '../../components/Tarif/Tarif';
import './Tarifs.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Tarifs = ({ listTarifs, isMajoration, isPrix, isEduc, isRempl, accroche = '' }) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <section id="tarifs" className="section-container">
      <h2 className="title">Mes tarifs</h2>
      <div className="text-content">
        {accroche && <p className="marge" dangerouslySetInnerHTML={{ __html: accroche }} />}
        {isPrix && (<p className="marge">Les prix mentionnés peuvent varier. Je m’adapte à chaque situation client.</p>)}
      </div>
      <div className="team-container">
        {listTarifs.map((tarif) => (
          <Tarif
            key={tarif.title}
            title={tarif.title}
            subtitle={tarif.subtitle}
            image={tarif.image}
            description={tarif.description}
          />
        ))}
      </div>
      <div className='kilometre-flex'>
        {isRempl && (<div className="kilometre-container">
          <div className="text-content">
        <p>* La TVA mentionnée sur les prix est récupérable pour les assujettis, conformément à la législation fiscale en vigueur.</p>
        <p>** À partir de 50 chiens, un supplément de 15€ TTC par tranche de 10 animaux supplémentaires sera appliqué.</p>
      </div></div>)}
        <div className='kilometre-container'>

          <img src="/img/tarifs/voiture.svg" alt="Illustration voiture" />
          <div className="text-content">
            <p>Frais kilométriques 0,40€/km aller-retour + péages {isEduc && (<p>pour le premier cours d'éducation à la maison</p>)}</p>
          </div>
        </div>
        {isMajoration && (
          <div className='kilometre-container'>
            <img src="/img/tarifs/calendrier.svg" alt="Illustration Calendrier" />
            <div className="text-content">
              <p>Majoration des jours fériés de 40%</p>
            </div>
          </div>)}
        {isEduc && (<div className='kilometre-container'>
          <div className="text-content">
            <p>Paiement en plusieurs fois possible</p>
          </div>
        </div>)}
        

      </div>
      
    </section>
  );
};

export default Tarifs;